<div class="detailBorder">
    <label>Changes (newest on top)</label>
    <dx-data-grid #dataGrid width="auto" [columns]="$safeNavigationMigration(itemDisplay?.columns)" [dataSource]="$safeNavigationMigration(itemDisplay?.rows)"
        (onCellPrepared)="onCellPrepared($event)">
        <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
    </dx-data-grid>
</div>
